var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { DisplaySmall } from '../../../typography';
import { color, fontWeight, spacing } from '../../../constants';
import { ChartLine } from '../../../icons';
import { Legend } from '../../components/Legend';
import { Axis } from '../../Axis';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: ", ";\n  border-left: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: ", ";\n  border-left: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n"])), function (_a) {
    var height = _a.height;
    return height + "px;";
}, color.theme.divider.solid, color.theme.divider.solid);
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  height: ", ";\n  margin: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  height: ", ";\n  margin: ", ";\n"])), function (_a) {
    var height = _a.height;
    return height + "px";
}, function (_a) {
    var _b = _a.margins, right = _b.right, left = _b.left;
    return "0px " + right + "px 0px " + left + "px";
});
var Content = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-align: center;\n  max-width: 60%;\n"], ["\n  text-align: center;\n  max-width: 60%;\n"])));
var Message = styled(DisplaySmall)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: ", " auto 0;\n  color: ", ";\n  font-weight: ", ";\n  max-width: 60%;\n"], ["\n  margin: ", " auto 0;\n  color: ", ";\n  font-weight: ", ";\n  max-width: 60%;\n"])), spacing.default, color.theme.typography.subdued, fontWeight.bold);
export function EmptyGraph(_a) {
    var series = _a.series, accessors = _a.accessors, height = _a.height, margins = _a.margins, message = _a.message, colorScheme = _a.colorScheme, _b = _a.axesProps, axesProps = _b === void 0 ? {} : _b;
    var emptySet = React.useMemo(function () { return new Set(); }, []);
    var axisMargins = React.useMemo(function () { return ({ bottom: 0, top: 0, left: 0, right: 0 }); }, [margins]);
    var boundedHeight = React.useMemo(function () { return height - margins.top - margins.bottom; }, [margins]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Wrapper, { margins: margins, height: height },
            React.createElement(Container, { height: boundedHeight },
                React.createElement(Content, null,
                    React.createElement(ChartLine, { large: true }),
                    React.createElement(Message, null, message))),
            (axesProps === null || axesProps === void 0 ? void 0 : axesProps.bottom) !== undefined && (React.createElement(Axis, __assign({}, axesProps.bottom, { orientation: "bottom", margins: axisMargins, height: margins.bottom, top: 0, isCanvasChild: false })))),
        series !== undefined && (React.createElement(Legend, { activeSet: emptySet, series: series, accessors: accessors, colorScheme: colorScheme, onToggle: function () { }, marginLeft: 0, marginRight: 0 }))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=EmptyGraph.js.map